import $ from "jquery"
window.$ = $
window.jQuery = $

import "materialize-css/dist/js/materialize.min"

import "./contact"
import "./forms/userLoginForm"
import "./forms/userRegisterForm"
import "./forms/user2FAForm"
import "./forms/userResetPasswordStep1"
import "./forms/userResetPasswordStep2"
import "./forms/attendeeDeclinedReasonForm"
import Cookies from "js-cookie"

import {IsPageWithLocale} from "./lib/urlutils";

const lightTheme = "light";
const darkTheme = "dark";
const systemTheme = "system";

$(document).ready(function() {
    materializeInit();
    cookiePolicyInit();
    colorThemeSwitchInit();

    if (IsPageWithLocale("")) {
        $('#mainPageRegisterNowButton').click(function (e) {
            e.preventDefault();

            $('#homepageRegisterForm').submit();
        });
    }
});

function materializeInit() {
    M.Dropdown.init(document.querySelectorAll('.dropdown-trigger'));
    M.Modal.init(document.querySelectorAll('.modal'));
    M.Sidenav.init(document.querySelectorAll('.sidenav'));
    M.FormSelect.init(document.querySelectorAll('select'));
}

function cookiePolicyInit() {
    let cookieModalInstance = M.Modal.getInstance(document.getElementById('cookieModal'));
    if (!Cookies.get('isAccepted')) {
        setTimeout(function () {
            $('#cookieAcceptButton').click(function () {
                let date = new Date();
                date.setTime(date.getTime() + (365*24*60*60*1000));

                Cookies.set('isAccepted', true, {
                    expires: date
                });
                cookieModalInstance.close()
            });

            cookieModalInstance.open();
        }, 1000);
    }
}

function colorThemeSwitchInit() {
    let savedTheme = Cookies.get('colorTheme');
    if (savedTheme) {
        switchColorTheme(savedTheme);
    }

    $("#lightThemeSwitch").click(function () {
        switchColorTheme(lightTheme);
    });
    $("#lightThemeMobileSwitch").click(function () {
        switchColorTheme(lightTheme);
    });
    $("#darkThemeSwitch").click(function () {
        switchColorTheme(darkTheme);
    });
    $("#darkThemeMobileSwitch").click(function () {
        switchColorTheme(darkTheme);
    });
    $("#systemThemeSwitch").click(function () {
        switchColorTheme(systemTheme);
    });
    $("#systemThemeMobileSwitch").click(function () {
        switchColorTheme(systemTheme);
    });
}

function switchColorTheme(schema) {
    if (schema === systemTheme) {
        Cookies.remove('colorTheme', { path: '/' });
    } else {
        let date = new Date();
        date.setTime(date.getTime() + (365*24*60*60*1000));

        Cookies.set('colorTheme', schema, {
            expires: date,
            path: '/'
        });
    }

    let body = $('body');
    let lightThemaMark = $('#lightThemeSwitch > i');
    let darkThemaMark = $('#darkThemeSwitch > i');
    let systemThemaMark = $('#systemThemeSwitch > i');
    let lightThemaMobileMark = $('#lightThemeMobileSwitch > i');
    let darkThemaMobileMark = $('#darkThemeMobileSwitch > i');
    let systemThemaMobileMark = $('#systemThemeMobileSwitch > i');

    $(lightThemaMark).html("");
    $(darkThemaMark).html("");
    $(systemThemaMark).html("");

    $(lightThemaMobileMark).html("");
    $(darkThemaMobileMark).html("");
    $(systemThemaMobileMark).html("");

    switch (schema) {
        case lightTheme:
            $(body).addClass('light-theme');
            $(body).removeClass('dark-theme');
            $(lightThemaMark).html("check");
            $(lightThemaMobileMark).html("check");
            break;
        case darkTheme:
            $(body).addClass('dark-theme');
            body.removeClass('light-theme');
            $(darkThemaMark).html("check");
            $(darkThemaMobileMark).html("check");
            break;
        case systemTheme:
            $(body).removeClass('dark-theme');
            body.removeClass('light-theme');
            $(systemThemaMark).html("check");
            $(systemThemaMobileMark).html("check");
            break;
    }

    let sidenav = M.Sidenav.getInstance(document.getElementById('mobile-menu'));
    if (sidenav) {
        sidenav.close();
    }
}
